import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type FloatingTimeEntryStateFragment = { __typename?: 'FloatingTimeEntryStateData', floatingTimeEntryId: string, workerId: string, status: Types.FloatingTimeEntryStatus, startTime?: Types.TDateISO | null, endTime?: Types.TDateISO | null, duration?: unknown | null, allocatedDuration: unknown, remainingDuration: unknown, allocations: Array<{ __typename?: 'FloatingTimeEntryAllocationData', taskAssignmentId: string, duration: unknown }> };

export type ActiveFloatingTimeEntrySummaryFragment = { __typename?: 'FloatingTimeEntryDocument', headcount: number, id: string, floatingTimeEntryId: string, workerId: string, status: Types.FloatingTimeEntryStatus, startTime?: Types.TDateISO | null, endTime?: Types.TDateISO | null, remainingDuration: unknown, isStale: boolean, allocations: Array<{ __typename?: 'FloatingTimeEntryAllocationDocument', taskAssignmentId: string }> };

export type GetActiveFloatingTimeEntriesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.FloatingTimeEntryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.FloatingTimeEntryDocumentSortInput> | Types.FloatingTimeEntryDocumentSortInput>;
}>;


export type GetActiveFloatingTimeEntriesQuery = { __typename?: 'Query', floatingTimeEntries?: { __typename?: 'FloatingTimeEntriesConnection', totalCount: number, nodes?: Array<{ __typename?: 'FloatingTimeEntryDocument', headcount: number, id: string, floatingTimeEntryId: string, workerId: string, status: Types.FloatingTimeEntryStatus, startTime?: Types.TDateISO | null, endTime?: Types.TDateISO | null, remainingDuration: unknown, isStale: boolean, allocations: Array<{ __typename?: 'FloatingTimeEntryAllocationDocument', taskAssignmentId: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetLoggedFloatingTimeEntriesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.FloatingTimeEntryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.FloatingTimeEntryDocumentSortInput> | Types.FloatingTimeEntryDocumentSortInput>;
}>;


export type GetLoggedFloatingTimeEntriesQuery = { __typename?: 'Query', floatingTimeEntries?: { __typename?: 'FloatingTimeEntriesConnection', totalCount: number, nodes?: Array<{ __typename?: 'FloatingTimeEntryDocument', floatingTimeEntryId: string, startTime?: Types.TDateISO | null, allocations: Array<{ __typename?: 'FloatingTimeEntryAllocationDocument', taskAssignmentId: string, duration: unknown }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const FloatingTimeEntryStateFragmentDoc = new TypedDocumentString(`
    fragment FloatingTimeEntryState on FloatingTimeEntryStateData {
  floatingTimeEntryId
  workerId
  status
  startTime
  endTime
  duration
  allocatedDuration
  remainingDuration
  allocations {
    taskAssignmentId
    duration
  }
}
    `, {"fragmentName":"FloatingTimeEntryState"});
export const ActiveFloatingTimeEntrySummaryFragmentDoc = new TypedDocumentString(`
    fragment ActiveFloatingTimeEntrySummary on FloatingTimeEntryDocument {
  headcount
  id
  floatingTimeEntryId
  workerId
  status
  startTime
  endTime
  remainingDuration
  isStale
  allocations {
    taskAssignmentId
  }
}
    `, {"fragmentName":"ActiveFloatingTimeEntrySummary"});
export const GetActiveFloatingTimeEntriesDocument = new TypedDocumentString(`
    query GetActiveFloatingTimeEntries($first: Int, $after: String, $where: FloatingTimeEntryDocumentFilterInput, $order: [FloatingTimeEntryDocumentSortInput!]) {
  floatingTimeEntries(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      ...ActiveFloatingTimeEntrySummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ActiveFloatingTimeEntrySummary on FloatingTimeEntryDocument {
  headcount
  id
  floatingTimeEntryId
  workerId
  status
  startTime
  endTime
  remainingDuration
  isStale
  allocations {
    taskAssignmentId
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetLoggedFloatingTimeEntriesDocument = new TypedDocumentString(`
    query GetLoggedFloatingTimeEntries($first: Int, $after: String, $where: FloatingTimeEntryDocumentFilterInput, $order: [FloatingTimeEntryDocumentSortInput!]) {
  floatingTimeEntries(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      floatingTimeEntryId
      startTime
      allocations {
        taskAssignmentId
        duration
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetActiveFloatingTimeEntries: build.query<GetActiveFloatingTimeEntriesQuery, GetActiveFloatingTimeEntriesQueryVariables | void>({
      query: (variables) => ({ document: GetActiveFloatingTimeEntriesDocument, variables })
    }),
    GetLoggedFloatingTimeEntries: build.query<GetLoggedFloatingTimeEntriesQuery, GetLoggedFloatingTimeEntriesQueryVariables | void>({
      query: (variables) => ({ document: GetLoggedFloatingTimeEntriesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetActiveFloatingTimeEntriesQuery, useLazyGetActiveFloatingTimeEntriesQuery, useGetLoggedFloatingTimeEntriesQuery, useLazyGetLoggedFloatingTimeEntriesQuery } = injectedRtkApi;
